import status from "../constants/status";
import { dateGreaterThan, localParse } from "./date"

export default (currentCounts, invoice, direction) => {
    let counts = { ...currentCounts };
    const amount = direction === 'add' ? 1 : -1
    counts["All jobs"] = counts["All jobs"] + amount;
    const invStatus = status(invoice.status)
    if (invStatus === "Waiting Payment") {
      counts["Waiting payment"] = counts["Waiting payment"] + amount;
    } 
    if (invStatus !== 'Order Complete'){
      counts["Current jobs"] = counts["Current jobs"] + amount;
    }
    if (invoice.owe !== invoice.paid){
      counts["Jobs with balance"] = counts["Jobs with balance"] + amount;
    }
    if (invStatus !== 'Order Complete' && dateGreaterThan(invoice.orderdue, localParse())) {
      counts["Past due"] = counts["Past due"] + amount
    }
    return counts
  }